import React from "react";

import {
  InfoCircleIcon,
  CalendarIcon,
  ClockIcon,
  PersonIcon,
} from "../../images/icons/icons";
import InfoPopover from "./pt-reports/re-usablee/InfoPopover";
import {
  formatDateTimezon,
  convertTo12HourFormat,
  convertStraight,
} from "../common-data/Converts";
import SortableHeader from "../common-components/SortableHeader";

export const createSortableColumns = ({
  handleSort,
  getSortDirection,
  isFieldSorted,
  handleInfoClick,
  setClickValues,
  activePopover,
  setActivePopover,
}) => {
  return [
    {
      dataField: "last_checkin",
      text: (
        <SortableHeader
          text="Member Last Checkin"
          field="last_checkin"
          onSort={handleSort}
          sortDirection={getSortDirection("last_checkin")}
          isSorted={isFieldSorted("last_checkin")}
        />
      ),
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span
              className="tb-data tb-link tb-info-icon"
              onClick={(e) => handleInfoClick(row, "checkin", e)}
            >
              <InfoCircleIcon />
              <InfoPopover
                isVisible={activePopover === `${row.uid}-checkin`}
                onClose={() => setActivePopover(null)}
                title="Member Last Check-in"
                data={[
                  {
                    label: "Date",
                    value: formatDateTimezon(row?.last_checkin),
                    fallback: "Never",
                    icon: <CalendarIcon color="#2c3e50" />,
                  },
                  {
                    label: "Time",
                    value: convertTo12HourFormat(row?.checkin_time),
                    fallback: "N/A",
                    icon: <ClockIcon color="#2c3e50" />,
                  },
                  {
                    label: "Days Ago",
                    value: row?.last_checkin_days_ago?.replace(/_/g, " "),
                    fallback: "N/A",
                    icon: <PersonIcon color="#2c3e50" />,
                  },
                ]}
                position="bottom"
              />
            </span>

            <span
              className="tb-data tb-link"
              onClick={() =>
                setClickValues((prevs) => ({
                  ...prevs,
                  userId: row?.user_id,
                  type: "member",
                  isModOpen: true,
                  name: "checkinLogsModal",
                }))
              }
            >
              {row?.last_checkin ? formatDateTimezon(row.last_checkin) : "-"}{" "}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "assigned_date",
      text: (
        <SortableHeader
          text="Handover Date"
          field="assigned_date"
          onSort={handleSort}
          sortDirection={getSortDirection("assigned_date")}
          isSorted={isFieldSorted("assigned_date")}
        />
      ),
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">
              {row?.assigned_date ? formatDateTimezon(row.assigned_date) : "-"}
            </span>

            <span className="tb-data underline gray">
              {row?.assigned_date_days_ago
                ? `(${row.assigned_date_days_ago?.replace(/_/g, " ")})`
                : ""}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "pt_schedule_date",
      text: (
        <SortableHeader
          text="PT Schedule Date"
          field="pt_schedule_date"
          onSort={handleSort}
          sortDirection={getSortDirection("pt_schedule_date")}
          isSorted={isFieldSorted("pt_schedule_date")}
        />
      ),
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.pt_schedule_date
              ? convertStraight(row.pt_schedule_date)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "pt_initiate_date",
      text: (
        <SortableHeader
          text="Trial Date"
          field="pt_initiate_date"
          onSort={handleSort}
          sortDirection={getSortDirection("pt_initiate_date")}
          isSorted={isFieldSorted("pt_initiate_date")}
        />
      ),
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">
              {row?.pt_initiate_date
                ? formatDateTimezon(row.pt_initiate_date)
                : "-"}
            </span>
            <span className="tb-data underline gray">
              {row?.pt_initiate_date_days_ago
                ? `(${row.pt_initiate_date_days_ago?.replace(/_/g, " ")})`
                : ""}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "date_added",
      text: (
        <SortableHeader
          text="Schedule Date"
          field="date_added"
          onSort={handleSort}
          sortDirection={getSortDirection("date_added")}
          isSorted={isFieldSorted("date_added")}
        />
      ),
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </span>
        );
      },
    },
  ];
};
